import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiSearch, FiFilter, FiEye, FiDownload } from 'react-icons/fi';
import api from '../../utils/api';
import TiltCard from '../effects/TiltCard';
const categories = ['semua','pendidikan','kesehatan','ekonomi','infrastruktur','kependudukan','pertanian','pariwisata','sosial','lingkungan','pemerintahan'];


const DatasetPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [datasets, setDatasets] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1 });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(searchParams.get('search') || '');
  const [kategori, setKategori] = useState(searchParams.get('kategori') || 'semua');
  const [type, setType] = useState(searchParams.get('type') || 'datasheet');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const params = { page: searchParams.get('page') || 1, limit: 12 };
        if (kategori && kategori !== 'semua') params.kategori = kategori;
        if (search) params.search = search;
        if (type && type !== 'all') params.type = type;
        const res = await api.get('/datasets', { params });
        setDatasets(res.data.data);
        setPagination(res.data.pagination);
      } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    load();
  }, [searchParams, kategori, search]);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchParams({ search, kategori: kategori !== 'semua' ? kategori : '', page: 1 });
  };

  const handleKategori = (kat) => {
    setKategori(kat);
    setSearchParams({ search, kategori: kat !== 'semua' ? kat : '', type, page: 1 });
  };

  const handleType = (t) => {
    setType(t);
    setSearchParams({ search, kategori: kategori !== 'semua' ? kategori : '', type: t, page: 1 });
  };

  const handlePage = (p) => {
    setSearchParams({ search, kategori: kategori !== 'semua' ? kategori : '', type, page: p });
    window.scrollTo(0, 0);
  };

  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <div className="container-wide">
        {/* Header */}
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', marginBottom: '0.5rem' }}>Dataset Sektoral</h1>
          <p style={{ color: 'var(--gray-500)' }}>Temukan {pagination.total} dataset dari berbagai sektor pembangunan Kabupaten Ngada</p>
        </div>

        {/* Search */}
        <form onSubmit={handleSearch} className="search-bar" style={{ marginBottom: '1.5rem', maxWidth: '100%' }}>
          <FiSearch style={{ marginLeft: '1rem', color: 'var(--gray-400)' }} size={20} />
          <input type="text" placeholder="Cari dataset berdasarkan judul, deskripsi, atau tag..." value={search} onChange={(e) => setSearch(e.target.value)} />
          <button type="submit"><FiFilter style={{ marginRight: 4 }} /> Cari</button>
        </form>

        {/* Content Type Tabs */}
        <div style={{ display: 'flex', borderBottom: '2px solid var(--gray-100)', marginBottom: '2rem', gap: '2rem' }}>
          {[
            { id: 'datasheet', label: 'Datasheet', icon: '📊' },
            { id: 'statistik', label: 'Produk Statistik', icon: '📄' },
            { id: 'visual', label: 'Visualisasi', icon: '🎨' }
          ].map(t => (
            <button key={t.id} onClick={() => handleType(t.id)} style={{ paddingBottom: '0.75rem', borderBottom: type === t.id ? '2px solid var(--primary-600)' : '2px solid transparent', color: type === t.id ? 'var(--primary-700)' : 'var(--gray-500)', fontWeight: type === t.id ? 600 : 400, display: 'flex', alignItems: 'center', gap: '0.5rem', transition: 'all 0.3s' }}>
              <span>{t.icon}</span> {t.label}
            </button>
          ))}
        </div>

        {/* Filter chips */}
        <div className="filter-chips" style={{ marginBottom: '2rem' }}>
          {categories.map(kat => (
            <button key={kat} className={`filter-chip ${kategori === kat ? 'active' : ''}`} onClick={() => handleKategori(kat)}>
              {kat === 'semua' ? 'Semua' : kat.charAt(0).toUpperCase() + kat.slice(1)}
            </button>
          ))}
        </div>

        {/* Results */}
        {loading ? (
          <div className="loading-spinner"><div className="spinner" /></div>
        ) : datasets.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📊</div>
            <h3>Tidak ada dataset ditemukan</h3>
            <p>Coba ubah kata kunci atau filter pencarian Anda</p>
          </div>
        ) : (
          <>
            <div className="dataset-grid" style={{ perspective: '1000px' }}>
              {datasets.map(ds => (
                <Link to={`/dataset/${ds._id}`} key={ds._id} style={{ textDecoration: 'none' }}>
                  <TiltCard className={`dataset-card ${ds.type}`}>
                    {ds.type === 'visual' && ds.thumbnail && (
                      <div style={{ height: 160, overflow: 'hidden', borderBottom: '1px solid var(--gray-100)' }}>
                        <img src={ds.thumbnail} alt={ds.judul} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </div>
                    )}
                    <div className="card-top">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <span className={`card-kategori kat-${ds.kategori}`}>{ds.kategori}</span>
                        {ds.type === 'statistik' && <span style={{ fontSize: '0.7rem', background: '#dbeafe', color: '#1d4ed8', padding: '2px 8px', borderRadius: 12 }}>PDF</span>}
                      </div>
                      <h4 style={{ marginTop: '0.75rem' }}>{ds.judul}</h4>
                      <p className="card-desc">{ds.deskripsi}</p>
                    </div>
                    <div className="card-bottom">
                      <div>
                        {ds.type === 'datasheet' ? (
                          <>
                            <span className="card-value">{ds.nilaiTerakhir?.toLocaleString('id-ID')}</span>
                            {ds.satuan && <span style={{ fontSize: '0.7rem', color: 'var(--gray-400)', marginLeft: '0.25rem' }}>{ds.satuan}</span>}
                          </>
                        ) : ds.type === 'statistik' ? (
                          <span style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', color: 'var(--primary-600)' }}><FiDownload /> Download Laporan</span>
                        ) : (
                          <span style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', color: 'var(--accent-600)' }}>👁️ Lihat Hub Visual</span>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', fontSize: '0.7rem', color: 'var(--gray-400)' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}><FiEye size={10} /> {ds.viewCount || 0}</span>
                      </div>
                    </div>
                  </TiltCard>
                </Link>
              ))}
            </div>

            {/* Pagination */}
            {pagination.pages > 1 && (
              <div className="pagination" style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
                <button onClick={() => handlePage(pagination.page - 1)} disabled={pagination.page <= 1}>&laquo;</button>
                {/* Dynamic Pagination Windows */}
                {(() => {
                  const pages = [];
                  const start = Math.max(1, pagination.page - 2);
                  const end = Math.min(pagination.pages, pagination.page + 2);
                  if (start > 1) pages.push(1, '...');
                  for (let i = start; i <= end; i++) pages.push(i);
                  if (end < pagination.pages) pages.push('...', pagination.pages);
                  return pages.map((p, i) => (
                    <button key={i} className={p === pagination.page ? 'active' : ''} disabled={p === '...'} onClick={() => handlePage(p)}>{p}</button>
                  ));
                })()}
                <button onClick={() => handlePage(pagination.page + 1)} disabled={pagination.page >= pagination.pages}>&raquo;</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DatasetPage;
